import { useEffect } from "react";

export function useSEO({ title, description, keywords }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
    if (keywords) {
      let meta = document.querySelector('meta[name="keywords"]');
      if (!meta) { meta = document.createElement("meta"); meta.name = "keywords"; document.head.appendChild(meta); }
      meta.setAttribute("content", Array.isArray(keywords) ? keywords.join(", ") : keywords);
    }
  }, [title, description, keywords]);
}

export function addJsonLd(schema) {
  const existing = document.querySelector('script[type="application/ld+json"][data-seo="flyinvisa"]');
  if (existing) existing.remove();
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.dataset.seo = "flyinvisa";
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
}
